var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-snackbar',_vm._b({attrs:{"timeout":_vm.timeout,"transition":"slide-y-reverse-transition"},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},'v-snackbar',{
    ..._vm.$attrs,
    color: 'transparent',
  },false),[_c('v-alert',{staticClass:"ma-0",attrs:{"color":_vm.$attrs.color,"dismissible":_vm.dismissible,"type":_vm.type,"dark":""},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }